import React from 'react'
import { Switch, Route } from 'react-router-dom'
import * as router from '../constants/router'

export default function Routes() {
    return (
        <Switch>
            {router.routerList.map((obj, index) => (
                <Route key={index} exact path={obj.router}>
                    {obj.page}
                </Route>
            ))}
        </Switch>
    )
}

function RoutesLogin() {
    return (
        <Switch>
            {router.routerListLogin.map((obj, index) => (
                <Route key={index} exact path={obj.router}>
                    {obj.page}
                </Route>
            ))}
        </Switch>
    )
}

export {
    RoutesLogin
}